import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { UserOrgRole } from "@prisma/client";

interface Organization {
  id: string;
  name: string;
  userOrgRole?: UserOrgRole;
}

interface OrganizationsState {
  currentOrganization: Organization | null;
  loading: boolean;
  error: string | null;
}

const initialState: OrganizationsState = {
  currentOrganization: null,
  loading: false,
  error: null,
};

const organizationsSlice = createSlice({
  name: "organizations",
  initialState,
  reducers: {
    setOrganization: (state, action: PayloadAction<Organization>) => {
      state.currentOrganization = action.payload;
      state.loading = false;
      state.error = null;
    },
    setOrganizationLoading: (state, action: PayloadAction<boolean>) => {
      state.loading = action.payload;
    },
    setOrganizationError: (state, action: PayloadAction<string>) => {
      state.error = action.payload;
      state.loading = false;
    },
    updateOrganizationName: (state, action: PayloadAction<string>) => {
      if (state.currentOrganization) {
        state.currentOrganization.name = action.payload;
      }
    },
  },
});

export const {
  setOrganization,
  setOrganizationLoading,
  setOrganizationError,
  updateOrganizationName,
} = organizationsSlice.actions;

export default organizationsSlice.reducer;
